import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LangData from "../common/LangData";
import { fetchData, policyNameId } from "../../utils/utils";
import { toast } from "react-toastify";
// import { useHistory } from "react-router-dom";
// import axios from "axios";

function PolicyFormPreviewCustomer() {
  const { policyId } = useParams();
  const [policyData, setPolicyData] = useState(null);
  const [personalData, setPersonalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomerPolicyDetails = async () => {
      try {
        setLoading(true);
        setError(null);

        if (!policyId) {
          setError("Policy ID is required");
          setLoading(false);
          return;
        }

        const result = await fetchData("customer-end-policy-details", {
          customer_policy_id: policyId,
        }).catch((err) => {
          if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
            throw new Error('Network error: Please check your internet connection');
          }
          throw err;
        });

        if (!result) {
          throw new Error('No response received from server');
        }

        if (result?.success) {
          const policyDetails = result?.data?.data?.customer_policy_details || {};
          setPersonalData(policyDetails);
          setPolicyData(policyDetails);
        } else {
          throw new Error(result?.error || "Failed to fetch policy details");
        }
      } catch (err) {
        console.error('Error fetching policy details:', err);
        const errorMessage = err?.message || "An error occurred while fetching data";
        setError(errorMessage);
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    if (policyId) {
      fetchCustomerPolicyDetails();
    }
  }, [policyId]);

  // Helper function to safely get values with fallback
  const getValueOrNA = (value) => {
    return value ?? "N/A";
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "500px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "500px" }}
      >
        <div className="text-center">
          <i
            className="fas fa-exclamation-circle text-danger"
            style={{ fontSize: "48px", marginBottom: "20px" }}
          ></i>
          <h4 className="text-danger mb-3">Error</h4>
          <p className="text-muted">{error}</p>
          {/* <div className="mt-4">
            <button
              className="btn btn-primary"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div> */}
        </div>
      </div>
    );
  }

  if (!policyData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "500px" }}
      >
        <div className="text-center">
          <i
            className="fas fa-file-alt text-muted"
            style={{ fontSize: "48px", marginBottom: "20px" }}
          ></i>
          <h4 className="text-muted mb-3">No Policy Data Found</h4>
          <p className="text-muted">
            The policy details you're looking for are not available.
          </p>
          <div className="mt-4">
            <button
              className="btn btn-primary"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  const customer = policyData?.customer ?? {};
  const nominee = policyData?.nominee ?? {};
  console.log("all data",  policyData)
  const appointee = policyData?.appointee ?? {};

  return (
    <div className="container p-5">
      <div>
        <h4 className="mb-3">
          {/* <label htmlFor="" style={{ fontWeight: "bold", color: #004e8f }}> */}
          <label htmlFor="" style={{ fontWeight: "bold", color: "#004e8f" }}>
            {" "}
            <LangData keyname="label_plan_name" />
          </label>
        </h4>

        <div className="calculated-result row">
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                <LangData keyname="label_premium_calculator_plan_name" />:{" "}
              </span>{" "}
              {policyNameId[personalData?.plan]}
            </p>
          </div>
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                {" "}
                <LangData keyname="label_premium_calculator_customer_age" />:
              </span>{" "}
              {personalData?.customer_age}
            </p>
          </div>
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                <LangData keyname="label_premium_calculator_monthly_premium" />:{" "}
              </span>
              {/* {personalData?.premium_paying_term} */}
              {personalData?.premium}
            </p>
          </div>
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                <LangData keyname="label_premium_calculator_term" />:
              </span>{" "}
              {personalData?.term}
            </p>
          </div>
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                <LangData keyname="label_premium_calculator_mode" />:
              </span>{" "}
              {personalData.mode === "M"
                ? "Monthly"
                : personalData.mode === "Q"
                ? "Quarterly"
                : personalData.mode === "H"
                ? "Half Yearly"
                : personalData.mode === "Y"
                ? "Yearly"
                : personalData.mode === "N"
                ? "Single"
                : personalData.mode === "S"
                ? "Single"
                : "Unknown"}
            </p>
          </div>
          <div className="col-4 mb-2">
            {" "}
            <p>
              <span className="label" style={{ color: "red" }}>
                <LangData keyname="label_premium_calculator_sum_assured" />:
              </span>{" "}
              {personalData?.sum_assured}
            </p>
          </div>

          <div className="col-4 mb-2"></div>
        </div>
      </div>

      {/* Customer Information */}
      <div className="mb-4">
        <h4 classsName="mb-3">
          <label htmlFor="" style={{ fontWeight: "bold", color: "#004e8f" }}>
            {" "}
            <LangData keyname="label_personal_information" />
          </label>{" "}
        </h4>
        <div className="d-flex flex-wrap">
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_name" />
              </label>{" "}
              :{getValueOrNA(customer?.first_name)}{" "}
              {getValueOrNA(customer?.last_name)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label htmlFor="">
                <LangData keyname="label_policy_holder_gender" />
              </label>
              :{" "}
              {customer?.gender === "M"
                ? "Male"
                : customer?.gender === "F"
                ? "Female"
                : "NA"}
            </p>
          </div>

          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_date_of_birth" />
              </label>{" "}
              : {getValueOrNA(customer?.date_of_birth)}
            </p>
          </div>
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_national_id" />
              </label>{" "}
              : {getValueOrNA(customer?.national_id)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_nationality" />
              </label>{" "}
              : {getValueOrNA(customer?.nationality)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_father_name" />
              </label>{" "}
              : {getValueOrNA(customer?.father_name)}
            </p>
          </div>
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_mother_name" />
              </label>{" "}
              : {getValueOrNA(customer?.mother_name)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_place_of_birth" />
              </label>{" "}
              : {getValueOrNA(customer?.place_of_birth)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_present_address" />
              </label>{" "}
              : {getValueOrNA(customer?.present_address)}
            </p>
          </div>
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_mobile_number" />
              </label>{" "}
              : {getValueOrNA(customer?.mobile)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_email" />
              </label>{" "}
              : {getValueOrNA(customer?.email)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_education" />
              </label>{" "}
              : {getValueOrNA(customer?.education)}
            </p>
          </div>
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_occupation" />
              </label>{" "}
              : {getValueOrNA(customer?.occupation)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_annual_income" />
              </label>{" "}
              : {getValueOrNA(customer?.annual_income)}
            </p>
          </div>
        </div>
      </div>

      {/* Nominee Information */}
      <div className="mb-4">
        <h4 classsName="mb-3">
          <label for="" style={{ fontWeight: "bold", color: "#004e8f" }}>
            {" "}
            <LangData keyname="label_nominee_information" />
          </label>{" "}
        </h4>
        <div className="d-flex flex-wrap">
          <div className="col-4 mb-2 p-0">
            <p>
              <label>
                <LangData keyname="label_nominee_name" />
              </label>
              : {getValueOrNA(nominee?.first_name)}{" "}
              {getValueOrNA(nominee?.last_name)}
            </p>
          </div>

          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_nominee_relation" />
              </label>{" "}
              : {getValueOrNA(nominee?.relation)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_date_of_birth" />
              </label>{" "}
              : {getValueOrNA(nominee?.date_of_birth)}
            </p>
          </div>
          <div className="col-4 mb-2 p-0">
            <p>
              <label htmlFor="">
                <LangData keyname="label_nominee_gender" />
              </label>
              :{" "}
              {nominee?.gender === "M"
                ? "Male"
                : nominee?.gender === "F"
                ? "Female"
                : "NA"}
            </p>
          </div>

          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_national_id" />
              </label>{" "}
              : {getValueOrNA(nominee?.national_id)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_nationality" />
              </label>{" "}
              : {getValueOrNA(nominee?.nationality)}
            </p>
          </div>
          {/* <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_nominee_permanent_address" />
              </label>{" "}
              : {getValueOrNA(nominee?.permanent_address)}
            </p>
          </div> */}
          <div className="col-4 mb-2 p-0">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_nominee_holder_present_address" />
              </label>{" "}
              : {getValueOrNA(nominee?.present_address)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_mobile_number" />
              </label>{" "}
              : {getValueOrNA(nominee?.mobile)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_nominee_email" />
              </label>{" "}
              : {getValueOrNA(nominee?.email)}
            </p>
          </div>
        </div>
      </div>

      {/* Appointee Information */}
      {appointee && Object.keys(appointee).length > 0 && (
        <div className="mb-4">
          <h4 classsName="mb-3">
            <label for="" style={{ fontWeight: "bold", color: "#004e8f" }}>
              {" "}
              <LangData keyname="label_appointee_information" />
            </label>{" "}
          </h4>
          <div className="d-flex flex-wrap">
            <div className="col-4 mb-2">
              <p>
                <label>
                  <LangData keyname="label_appointee_name" />
                </label>
                : {getValueOrNA(appointee?.first_name)}{" "}
                {getValueOrNA(appointee?.last_name)}
              </p>
            </div>

            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_nominee_relation" />
                </label>{" "}
                : {getValueOrNA(appointee?.relation)}
              </p>
            </div>
            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_policy_holder_date_of_birth" />
                </label>{" "}
                : {getValueOrNA(appointee?.date_of_birth)}
              </p>
            </div>
            <div className="col-4 mb-2">
              <p>
                <label htmlFor="">
                  <LangData keyname="label_policy_holder_gender" />
                </label>
                :{" "}
                {appointee?.gender === "M"
                  ? "Male"
                  : appointee?.gender === "F"
                  ? "Female"
                  : "NA"}
              </p>
            </div>

            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_policy_holder_national_id" />
                </label>{" "}
                : {getValueOrNA(appointee?.national_id)}
              </p>
            </div>
            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_policy_holder_nationality" />
                </label>{" "}
                : {getValueOrNA(appointee?.nationality)}
              </p>
            </div>
            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_policy_holder_present_address" />
                </label>{" "}
                : {getValueOrNA(appointee?.present_address)}
              </p>
            </div>
            <div className="col-4 mb-2">
              <p>
                <label for="">
                  {" "}
                  <LangData keyname="label_mobile_number" />
                </label>{" "}
                : {getValueOrNA(appointee?.mobile)}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="mb-4">
        <h4 classsName="mb-3">
          <label for="" style={{ fontWeight: "bold", color: "#004e8f" }}>
            {" "}
            <LangData keyname="label_policy_holder_health_title" />
          </label>{" "}
        </h4>
        <div className="d-flex flex-wrap">
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_blood" />
              </label>{" "}
              : {getValueOrNA(policyData?.questions_answers
                ?.blood)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_pulse_rate" />
              </label>{" "}
              : {getValueOrNA(policyData?.questions_answers
                ?.pulse_rate)}
            </p>
          </div>
          
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_height" />
              </label>{" "}
              : {getValueOrNA(policyData?.questions_answers
                ?.height)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_weight" />
              </label>{" "}
              : {getValueOrNA(policyData?.questions_answers
                ?.weight)}
            </p>
          </div>
          <div className="col-4 mb-2">
            <p>
              <label for="">
                {" "}
                <LangData keyname="label_policy_holder_smoker_status" />
              </label>{" "}
              : {getValueOrNA(policyData?.questions_answers
                ?.smoker_status)}
            </p>
          </div>
        </div>
      </div>


      {/* Policy Questions */}
      <div>
        <h4 className="mb-3">
          <label for="" style={{ fontWeight: "bold", color: "#004e8f" }}>
            {" "}
            <LangData keyname="label_policy_Question" />
          </label>
        </h4>
        <ul className="list-group">
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_medical_practitioner" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_medical_practitioner_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_admitted_hospital" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_admitted_hospital_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_remained_absent" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_remained_absent_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_suffering_ailments_pertaining" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_suffering_ailments_pertaining_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_suffered_diabetes_others" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_suffered_diabetes_others_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_bodily_defect_deformity" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_bodily_defect_deformity_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_accident_injury" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_accident_injury_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_used_alcoholic_others" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_used_alcoholic_others_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_good_health" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers?.policy_holder_good_health_details
            )}
          </li>
          <li className="list-group-item">
            <label for="" style={{ fontSize: "14px" }}>
              {" "}
              <LangData keyname="label_policy_holder_aids_hepatitis" />
            </label>{" "}
            :{" "}
            {getValueOrNA(
              policyData?.questions_answers
                ?.policy_holder_aids_hepatitis_details
            )}
          </li>
        </ul>
      </div>

      {/* Document Preview & Download */}
      {policyData?.documents && (
        <div className="mb-4 mt-4">
          <h4 className="mb-3">
            <label htmlFor="" style={{ fontWeight: "bold", color: "#004e8f" }}>
              <LangData keyname="label_documents" />
            </label>
          </h4>

          <div className="d-flex align-items-center gap-3" style={{flexDirection: "column"}}>
            {policyData.documents.match(/\.(pdf)$/i) ? (
              <div className="document-icon">
                <i
                  className="fas fa-file-pdf"
                  style={{ fontSize: "48px", color: "#e74c3c" }}
                ></i>
              </div>
            ) : policyData.documents.match(
                /\.(jpg|jpeg|png|gif|bmp|webp)$/i
              ) ? (
              <div className="document-preview">
                <img
                  src={`https://licbangladesh.com/licadmin/public/${policyData.documents}`}
                  alt="Policy Document"
                  style={{
                    maxWidth: "200px",
                    maxHeight: "200px",
                    objectFit: "contain",
                  }}
                />
              </div>
            ) : (
              <div className="document-icon">
                <i
                  className="fas fa-file-alt"
                  style={{ fontSize: "48px", color: "#004e8f" }}
                ></i>
              </div>
            )}
            <div>
              <a
                href={`https://licbangladesh.com/licadmin/public/${policyData.documents}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                download
              >
                <i className="fas fa-download me-2"></i>
                <LangData keyname="label_download_document" />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PolicyFormPreviewCustomer;
